module.exports = __webpack_public_path__ + "static/media/icon_claim.e80b70b8.svg";


//////////////////
// WEBPACK FOOTER
// ./client/modules/ui/assets/icon_claim.svg
// module id = 1249
// module chunks = 0